import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import resellerReducer from "./resellerSlice";
import organizationReducer from "./organizationSlice";
import customerReducer from "./customerSlice";
import campaignReducer from "./campaignSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    reseller: resellerReducer,
    customer:customerReducer,
    campaign:campaignReducer,
    organization: organizationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
